import { Tabs } from '@/components';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

type TabKey = 'users' | 'organizations';

type Props = {
  type: TabKey;
};

export const HeaderTab: FC<Props> = ({ type }) => {
  const { t } = useTranslation();
  const { id } = useId();

  const navigate = useNavigate();
  return (
    <Tabs
      activeKey={type}
      items={[
        {
          key: 'users' satisfies TabKey,
          label: t('users-page'),
        },
        {
          key: 'organizations' satisfies TabKey,
          label: t('organizations-page'),
        },
      ]}
      onChange={(activeKey) => {
        navigate(`/tenant-manager/snapshots/${id}/${activeKey}`, {
          replace: true,
        });
      }}
    />
  );
};
